interface IHeadingSet {
  main: string;
  sub: string;
}

export const getBusinessDetailsHeadings = (isThirdParty: boolean): IHeadingSet => {
  if (isThirdParty) {
    return {
      main: 'Tell us about the customers business',
      sub: 'We’ll use these details to verify your business',
    };
  }

  return {
    main: 'Tell us about your business',
    sub: 'We’ll use these details to verify your business',
  };
};

export const getDirectorDetailsHeadings = (
  isThirdParty: boolean,
  directorType: string,
): IHeadingSet => {
  if (isThirdParty) {
    return {
      main: `Tell us about the customers ${directorType}s`,
      sub: 'Some confidential but necessary details to complete the customers application',
    };
  }

  return {
    main: `Tell us about your ${directorType}s`,
    sub: 'Some confidential but necessary details to complete your application',
  };
};

export const getConfirmAddressHeadings = (isThirdParty: boolean): IHeadingSet => {
  if (isThirdParty) {
    return {
      main: 'Confirm the customers company address',
      sub: 'Please ensure that the customer provides the correct address. This is where we will deliver their device.',
    };
  }

  return {
    main: 'Confirm your company address',
    sub: 'Please ensure that you provide the correct address. This is where we will deliver your device.',
  };
};

export const getResidentialAddressHeadings = (isThirdParty: boolean): IHeadingSet => {
  if (isThirdParty) {
    return {
      main: "What's the customers residential address?",
      sub: "Simply start filling in the street address and we'll do the rest",
    };
  }

  return {
    main: "What's your residential address?",
    sub: "Simply start filling in the street address and we'll do the rest",
  };
};

export const getPersonalDetailsHeadings = (isThirdParty: boolean): IHeadingSet => {
  if (isThirdParty) {
    return {
      main: 'Confirm the customers personal details',
      sub: 'Please ensure that the customer provides the correct authorised business representative details below.',
    };
  }

  return {
    main: 'Tell us about yourself',
    sub: 'We need your details as an authorised business representative',
  };
};

export const getBankDetailsHeadings = (isThirdParty: boolean): IHeadingSet => {
  if (isThirdParty) {
    return {
      main: "Customer's banking details",
      sub: "We need the customer's banking details to deposit their daily transactions.",
    };
  }

  return {
    main: 'Bank details',
    sub: 'We need your banking details to deposit your daily transactions.',
  };
};

export const getPersonalSelfieHeadings = (
  isThirdParty: boolean,
  isPendingApp: boolean,
  isPol?: boolean,
): IHeadingSet => {
  if (isThirdParty) {
    return {
      main: "Let's take a selfie of the customer",
      sub: isPol
        ? "We'll compare the customers picture to the documents they've submitted"
        : 'To proceed with the application, we need to verify the customers identity with a clear photo of their face',
    };
  }

  if (isPendingApp) {
    return {
      main: "Let's take a selfie",
      sub: 'Please retake your selfie.',
    };
  }

  return {
    main: "Let's take a selfie",
    sub: isPol
      ? "We'll compare your picture to the documents you've submitted"
      : 'To proceed with the application, we need to verify your identity with a clear photo of your face',
  };
};

interface OnboardingHeadingSet {
  main: string;
  second: string;
  third: string;
}

export const getOnboardingCompleteHeadings = (isThirdParty: boolean): OnboardingHeadingSet => {
  if (isThirdParty) {
    return {
      main: 'Congratulations! Application submitted. ',
      second: 'We’ll keep you and the customer updated on the progress of the application.',
      third: 'The customer should check their email with further instructions on how to proceed.',
    };
  }

  return {
    main: 'Congratulations! Your application has been submitted. ',
    second: `We’ll keep you updated on the progress of the application.`,
    third: 'Please check your email with further instructions on how to proceed.',
  };
};
